import { Component, Input, OnChanges, ElementRef, ViewChild, AfterViewChecked } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import Prism from 'prismjs';
import 'prismjs/components/prism-yaml';
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';

@Component({
  selector: 'app-yaml-viewer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './yaml-viewer.component.html',
  styleUrls: ['./yaml-viewer.component.scss']
})
export class YamlViewerComponent implements OnChanges, AfterViewChecked {
  @Input() yamlContent: string = '';
  yamlHtml: SafeHtml | null = null;

  private hasRendered: boolean = false;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnChanges(): void {
    if (this.yamlContent) {
      const highlightedCode = Prism.highlight(this.yamlContent, Prism.languages['yaml'], 'yaml');
      this.yamlHtml = this.sanitizer.bypassSecurityTrustHtml(highlightedCode);
      this.hasRendered = false;
    }
  }

  ngAfterViewChecked(): void {
    if (this.yamlContent && !this.hasRendered) {
      Prism.highlightAll();
      this.hasRendered = true; // Set the flag to prevent redundant calls
    }
  }
}